// extracted by mini-css-extract-plugin
module.exports = {"link":"AuthNav_link__2ejsg","active":"AuthNav_active__2WI0M","container":"AuthNav_container__2sSIa"};